<template>
  <div class="dropdownGroup descriptionGroup" v-if="isVisible">
    <div class="dropdownWrapper">
      <div class="item variant">
        <div v-for="(el, index) in cmpConfig.data.text" :key="index">
          {{ getCactusString(el) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import expertviewMixin from './experviewMixin';

export default {
  name: 'cwRoundTextBoxWrapper',
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$log.debug('cwRoundTextBoxWrapper::created()', this.cmpConfig);

    if (this.ruleSubscriber.length > 0) {
      this.applyRules();
    }
  }
};
</script>

<style scoped lang="scss">
.dropdownGroup {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  padding-bottom: 24px;

  .item {
    max-width: 96px;
    background-color: $cloudy-blue-20;
    border: 1px solid $cloudy-blue;
    border-radius: 8px;
    height: 80px;
    width: 100%;

    & > :first-child {
      display: block;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid $cloudy-blue;
      font-size: 14px;
      color: $petrol;
      text-align: center;

      & > :last-child {
        color: $cloudy-blue;
      }
    }

    & > :last-child {
      height: 40px;
      display: block;
      font-size: 14px;
      color: $petrol;
    }

    &.variant {
      & > :first-child,
      > :last-child {
        color: $petrol;
        display: block;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        text-align: center;
        & > :last-child {
          color: $cloudy-blue;
        }
      }
    }
  }

  &.descriptionGroup {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 24px;
    .item {
      &.variant {
        max-width: none;
        & > :first-child,
        > :last-child {
          color: $petrol;
          display: block;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          text-align: center;
          & > :last-child {
            color: $cloudy-blue;
          }
        }
      }
    }
  }
}
</style>
